import "./tournament-message-type.scss";
import {
  GSActionBar,
  GSItemList,
  GSSidePanelPage,
} from "golfstatus_react_components";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import { useMatch, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import NavigationListItem from "../../navigation-list-item";
import {
  createMessage,
  selectMessagesNotifications,
  clearNotifications,
} from "../../../reducers/messagesSlice";
import {
  useNotificationNavigation,
  useNotificationBanner,
} from "../../../hooks/notificationHooks";

const TournamentMessageType = () => {
  const navigate = useNavigate();
  const match = useMatch("/:tournamentID/messages/new");
  const dispatch = useDispatch();
  const notifications = useSelector(selectMessagesNotifications);

  useNotificationNavigation(
    "created",
    notifications,
    `/${match?.params?.tournamentID}/messages/[id]`
  );

  // Clearing created notification to not cause confusion on details page
  useEffect(() => {
    if (notifications?.[0]?.result === "created") {
      dispatch(clearNotifications());
    }
  }, [notifications, dispatch]);

  const messageTypes = [
    {
      label: "Email",
      details: "Send an email to tournament participants.",
      url: "email",
    },
    {
      label: "App Notification",
      details:
        "Send a notification to tournament participants through the GolfStatus App.",
      url: "notification",
    },
  ];

  const selectType = (page) => {
    dispatch(
      createMessage({
        tournamentID: match?.params?.tournamentID,
        data: {
          channel: page.url,
          tournaments: [{ id: match?.params?.tournamentID }],
        },
      })
    );
  };

  const goBack = () => {
    dispatch(clearNotifications());
    navigate(-1);
  };

  const getNavigation = () => {
    return {
      title: "Message Type",
      leftIcon: faChevronLeft,
      leftButtonClick: goBack,
    };
  };

  const getContent = () => {
    return (
      <gs-form>
        <GSActionBar type="form-header" header="Message Type" />
        <GSItemList
          type="vertical selectable"
          items={messageTypes}
          itemSelected={selectType}
          listItem={(item) => <NavigationListItem page={item} />}
        />
      </gs-form>
    );
  };

  const getDrawer = () => {
    return {
      actions: [
        {
          name: "Cancel",
          action: goBack,
          type: "light-grey",
        },
      ],
    };
  };

  const timeoutAction = () => {
    dispatch(clearNotifications());
  };

  const [banner] = useNotificationBanner({ notifications, timeoutAction });

  return (
    <tournament-message-type>
      <GSSidePanelPage
        header={getNavigation()}
        banner={banner}
        content={getContent()}
        drawer={getDrawer()}
      />
    </tournament-message-type>
  );
};

export default TournamentMessageType;
